import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SettingsProvider } from '@services/settings/settings';
import { takeUntil } from 'rxjs/operators';
import { CustomizedLabels } from '@models/models';

@Component({
	selector: 'client-card',
	template: require('./client-card.html'),
	styles: [require('./client-card.scss')]
})
export class ClientCardComponent implements OnInit, OnDestroy {
	@Input() client: any;
	@Input() type: string;
	@Input() gdprEnabled: boolean;
	@Output() onEdit: EventEmitter<any> = new EventEmitter();
	@Output() onSubscribe: EventEmitter<any> = new EventEmitter();
	@Output() onDelete: EventEmitter<any> = new EventEmitter();

	private businessNumberLabelName: string;

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	editClient(): void {
		this.onEdit.emit();
	}

	deleteClient(): void {
		this.onDelete.emit();
	}

	subscribeClient(): void {
		this.onSubscribe.emit();
	}

	showSaveOptInModal(): void {
		$('#saveOptinConsentModal').modal('show');
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.businessNumberLabelName = customizeLabels.businessNumberLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/client/client-card/client-card.ts